module.exports = fox._r("images/join-bg.jpg", __webpack_public_path__ + "images/join-bg.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/join-bg.jpg
// module id = 980
// module chunks = 4